<ppt-actions-toolbar
  [reportData]="reportRecordsData"
  [currentView]="currentView()"
  [templates]="templateFieldsCatalog"
  [recordsCount]="recordsCount"
  (navRecordNum)="navRecordNum($event)"
  [requiresSelectTempElement]="true"
  [requiresRecordNavigation]="false"
  [isUKFeaturesEnabled]="isUKFeaturesEnabled()"
  (templateChange)="onTemplateSelected($event)"
  (templateAndViewChange)="onTemplateSelectedLater($event)"
></ppt-actions-toolbar>
@if (isContactsVisible) {
  <rep-dynamic-contacts
    [contactGroups]="contactGroups"
    [currentView]="currentView()"
    [reportId]="reportData()?.reportId"
  ></rep-dynamic-contacts>
}
<ppt-actions-toolbar
  [reportData]="reportRecordsData"
  [currentView]="currentView()"
  [templates]="templateFieldsCatalog"
  [recordsCount]="recordsCount"
  (navRecordNum)="navRecordNum($event)"
  [requiresSelectTempElement]="false"
  [requiresRecordNavigation]="true"
  (templateChange)="onTemplateSelected($event)"
></ppt-actions-toolbar>
<div>
  <div class="ppt-record-body-wrapper">
    <ppt-record-body
      [reportData]="reportRecordsData"
      [recordNumber]="recordNumber"
      [headerGroups]="headerGroups"
      [groupsToDisplay]="bodyGroups"
      [currentView]="currentView()"
      [customConfigs]="customConfigs()"
      [confidentialityTmpl]="confidentialityTmpl()"
      [imageGroups]="imageGroups"
      [reportLocale]="reportLocale()"
      [templateProjectionMap]="templateProjectionMap()"
      (removeRecord)="removeRecord.emit($event)"
      (reportReordered)="reportReordered.emit($event)"
      (reportUpdateClick)="reportUpdateClick.emit($event)"
    ></ppt-record-body>
  </div>
</div>
